import { render, staticRenderFns } from "./widget-gtm-instructions.vue?vue&type=template&id=3b984e02&scoped=true&"
import script from "./widget-gtm-instructions.vue?vue&type=script&lang=js&"
export * from "./widget-gtm-instructions.vue?vue&type=script&lang=js&"
import style0 from "./widget-gtm-instructions.vue?vue&type=style&index=0&id=3b984e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b984e02",
  null
  
)

export default component.exports